import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const CounterPill = styled.div`
  /* Layout */
  padding: 0 ${tokens.spacer.x1};
  margin-right: ${tokens.spacer.x1pt5};
  height: 19px;

  background-color: ${tokens.color.neutral_300};
  border-radius: 16px;

  /*
    Custom font style from Figma
    https://www.figma.com/file/paNCfpw5Cq1xDd77dGZvz6/Multitab
  */
  font-size: 10px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: pre;
`;

interface Props {
  currentTabNo: number;
  totalTabNo: number;
}

export const TabCounter = ({ currentTabNo, totalTabNo }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <CounterPill>
      {t('common:player.url-bar.tab')}: {currentTabNo}/{totalTabNo}
    </CounterPill>
  );
};
